// extracted by mini-css-extract-plugin
module.exports = {"quote-on-media-content":"QuoteOnMediaBlock_quote-on-media-content__EvBXB","quote-on-media-body":"QuoteOnMediaBlock_quote-on-media-body__Bw_Yv"};